<template>
  <el-row class="xh-esg-attach">
    <el-col :span="24">
      <div class="xh-esg-attach-header">
        <div class="xh-esg-attach-header-title">小编推荐</div>
      </div>
      <div class="xh-esg-attach-bodyer">
        <div class="xh-esg-attach-bodyer-content">
          <div
            v-for="(item, index) in pageData"
            :key="index"
            @click="showRowData(item)"
          >
            <div  class="xh-esg-attach-bodyer-item" v-if="index < 5">
              <div :class="getIndexStyle(index)">
                {{ index + 1 }}.
              </div>
              <div class="xh-esg-attach-bodyer-item-text">
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {},
  data() {
    return {
      pageData: [],
    };
  },
  mounted() {
    this.getAttachList().then((data) => {
      this.pageData = data;
    });
  },
  methods: {
    ...mapActions("dynamicInfo/index", {
      getAttachList: "GET_ATTACH_LIST",
    }),
    getIndexStyle(index){
      let indexMapping = ["red", "orange", "blue"];
      let color = indexMapping[index] || ""
      return "xh-esg-attach-bodyer-item-index " + color;
    },
    showRowData({ newsId }) {
      let params = {
        path: "/dynamicInfo/detail",
        query: {
          newsId,
        },
      };
      this.$router.push(params);
    },
  },
};
</script>
<style lang="scss" scoped>
.xh-esg-attach {
  padding: 20px 0;
  .xh-esg-attach-header {
    border-bottom: 1px solid var(--comp_02);
    .xh-esg-attach-header-title {
      font-size: 12px;
      font-weight: bold;
      color: var(--font_01);
      display: inline-block;
      border-bottom: 2px solid #008bce;
      height: 22px;
    }
  }
  .xh-esg-attach-bodyer {
    min-height: 120px;
    .xh-esg-attach-bodyer-item {
      cursor: pointer;
      padding-top: 14px;
      display: flex;

      .xh-esg-attach-bodyer-item-index {
        font-size: 12px;
        font-weight: 400;
        color: var(--font_01);
        line-height: 14px;
        &.red{
          color: #E54724
        }
        &.orange{
          color: #FAA90D
        }
        &.blue{
          color: #008BCE
        }
      }
      .xh-esg-attach-bodyer-item-text {
        font-size: 12px;
        font-weight: 400;
        color: var(--font_01);
        line-height: 14px;
        margin-left: 5px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>